

export const frontMatter = {
	sidebar_position: 2
};
export const contentTitle = 'Keyboards';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-resources-keyboards-md-4de.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Windows",
  "id": "windows",
  "level": 3
}, {
  "value": "Mac",
  "id": "mac",
  "level": 3
}, {
  "value": "Linux and BSD",
  "id": "linux",
  "level": 3
}, {
  "value": "Android",
  "id": "android",
  "level": 3
}, {
  "value": "Other platforms",
  "id": "other-platforms",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "keyboards",
        children: "Keyboards"
      })
    }), "\n", _jsx(_components.h3, {
      id: "windows",
      children: "Windows"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://tyflonet.com/siciliano/klaviatury",
        children: "http://tyflonet.com/siciliano/klaviatury"
      })
    }), "\n", _jsx(_components.h3, {
      id: "mac",
      children: "Mac"
    }), "\n", _jsx(_components.p, {
      children: "TODO: add links"
    }), "\n", _jsx(_components.h3, {
      id: "linux",
      children: "Linux and BSD"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Extended MS Latin on international Latin keyboards (such as hrvatska in the unicodeus variant)."
      }), "\n", _jsx(_components.li, {
        children: "Full Cyrillic keyboard is on a standard Ukrainian keyboard."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "android",
      children: "Android"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "http://usachov.eu/g",
        children: "http://usachov.eu/g"
      })
    }), "\n", _jsx(_components.h3, {
      id: "other-platforms",
      children: "Other platforms"
    }), "\n", _jsx(_components.p, {
      children: "If there is no keyboard for your platform, you can try using some built-in keyboard layouts:"
    }), "\n", _jsxs(_components.p, {
      children: ["For the ", _jsx(_components.strong, {
        children: "Interslavic Latin"
      }), " alphabet:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Czech (standard, partially etymological)"
      }), "\n", _jsx(_components.li, {
        children: "Croatian (exempted)"
      }), "\n", _jsx(_components.li, {
        children: "Serbian (exonerated)"
      }), "\n", _jsx(_components.li, {
        children: "Slovenian (exempted)"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["For the ", _jsx(_components.strong, {
        children: "Interslavic Cyrillic"
      }), " alphabet:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Serbian (exempted, without \"Ы\")"
      }), "\n"]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

